import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { Ng9RutModule } from 'ng9-rut';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedViewsModule } from '../shared/shared-views.module';

import { EmpresasEmitidosDetalleHistoricoComponent } from './empresas-emitidos/detalle-historico/detalle-historico.component';
import { EmpresasEmitidosDetalleComponent } from './empresas-emitidos/detalle/detalle.component';
import { EmpresasEmitidosComponent } from "./empresas-emitidos/empresas-emitidos.component";

import { EmpresasRecibidosComponent } from "./empresas-recibidos/empresas-recibidos.component";
import { EmpresasRecibidosModalObservacionesComponent } from './empresas-recibidos/modal-observaciones/modal-observaciones.component';
import { EmpresasRecibidosModalRespComComponent } from './empresas-recibidos/modal-resp-com/modal-resp-com.component';
import { ModalAgregarDocumentoRecibidoComponent } from './empresas-recibidos/table-importacion/modal-add-doc-recibido/modal-add-doc-recibido.component';
import { ModalAddEditEquivalenciaComponent } from './empresas-recibidos/table-importacion/modal-add-edit-equivalencia/modal-add-edit-equivalencia/modal-add-edit-equivalencia.component';
import { ModalConfirmPeriodoGestionComponent } from './empresas-recibidos/table-importacion/modal-confirm-periodo-gestion/modal-confirm-periodo-gestion.component';
import { ModalDocumentoProcesadoResultadoComponent } from './empresas-recibidos/table-importacion/modal-doc-procesado-resultado/modal-doc-procesado-resultado.component';
import { EmpresasRecibidosModalObservacionesNoProcesadasComponent } from './empresas-recibidos/table-importacion/modal-observaciones-no-procesadas/modal-observaciones-no-procesadas.component';
import { EmpresasRecibidosTableImportacionComponent } from './empresas-recibidos/table-importacion/table-importacion.component';
import { EmpresasRecibidosTableIntercambioEmpresasComponent } from './empresas-recibidos/table-intercambio-empresas/table-intercambio-empresas.component';
import { EmpresasRecibidosTableIntercambioSIIComponent } from './empresas-recibidos/table-intercambio-sii/table-intercambio-sii.component';

@NgModule({
  declarations: [
    EmpresasEmitidosComponent,
    EmpresasEmitidosDetalleComponent,
    EmpresasEmitidosDetalleHistoricoComponent,
    EmpresasRecibidosComponent,
    EmpresasRecibidosTableIntercambioEmpresasComponent,
    EmpresasRecibidosTableIntercambioSIIComponent,
    EmpresasRecibidosTableImportacionComponent,
    EmpresasRecibidosModalObservacionesComponent,
    EmpresasRecibidosModalObservacionesNoProcesadasComponent,
    ModalConfirmPeriodoGestionComponent,
    EmpresasRecibidosModalRespComComponent,
    ModalAgregarDocumentoRecibidoComponent,
    ModalDocumentoProcesadoResultadoComponent,
    ModalAddEditEquivalenciaComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    Ng9RutModule,
    FormsModule,
    ReactiveFormsModule,
    SharedViewsModule,
    SharedModule
  ],
  exports: [
    EmpresasEmitidosComponent,
    EmpresasRecibidosComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class AnalisisEventosModule { }
